import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { catchError } from 'rxjs';
import { CommonService } from '../../services/common.service';
import { NgForm } from '@angular/forms';
import { AdministrationService } from 'src/app/components/administration/administration.service';
import { ToastrService } from 'ngx-toastr';
import { GetAllMetalResponseModel } from 'src/app/components/administration/administration.model';
import { SendDataService } from '../../services/send-data.service';

@Component({
  selector: 'app-metal',
  templateUrl: './metal.component.html',
  styleUrls: ['./metal.component.scss']
})
export class MetalComponent extends CommonService implements OnInit{
  @ViewChild('administrationFormData') administrationFormData! : NgForm ;
  getAllMetalData          : any[]=[];
  isAdd                    : boolean = false;

  copyGetAllMetalData          : any[]=[]
  editMetalData                = new GetAllMetalResponseModel();

constructor(
  public renderer:Renderer2,
  public administrationService : AdministrationService,
  public toaster: ToastrService,
  public sendDataService : SendDataService,
) 
{
  super(renderer)
}

ngOnInit(): void {
  this.getAllMetalList();
}

add(){
  if(!this.sendDataService?.permissionVM?.mastersCanAdd) return;
  this.isAdd = true;
  const obj = {id:0, name:'',hsnCode:'',active:true,systemName:''}
  this.getAllMetalData?.push(obj);
  this.copyGetAllMetalData?.push(obj);
  setTimeout(()=>{
    const element = document.getElementById(`metalName${obj.id}`);
    element?.focus();
  },0)
}


cancel(){
  // if(this.isAdd)
  // {
  //   this.isAdd = false;
  //   this.getAllMetalData = this.getAllMetalData.filter((x)=>x.id != 0);
  //   this.copyGetAllMetalData = this.copyGetAllMetalData.filter((x)=>x.id != 0);
  // }
  if(this.editMetalData?.id && this.editMetalData?.isEdit){
    const index = this.copyGetAllMetalData.findIndex((x)=>x.id == this.editMetalData?.id);
    const singleData =JSON.parse(JSON.stringify(this.copyGetAllMetalData))[index];
    this.getAllMetalData[index] = singleData;
    this.editMetalData = new GetAllMetalResponseModel();
  }  
}

edit(item,formData){
  if(!this.sendDataService?.permissionVM?.mastersCanUpdate) return;
  item.isEdit = true;
  const controlObj = formData?.form?.controls;
  if(controlObj){
    const id = Object.keys(controlObj)[0];
    const element = document.getElementById(id);
    element?.focus();
  }
  this.editMetalData = {...item};
}

checkIsEdit(arr:any[]):boolean{
  return arr?.some((x)=>x.isEdit)
}

  // *********** METAL API START *********
  // **********get all Metal *********
  getAllMetalList() {
    this.administrationService.getAllMetalData = [];
    this.administrationService.getAllMetal().subscribe({
      next:(res)=>{
        if(res.isSuccess){
          this.getAllMetalData = res.response??[];
          this.administrationService.getAllMetalData = JSON.parse(JSON.stringify(this.getAllMetalData.filter((x)=>x.active==true)))??[];
          this.editMetalData = new GetAllMetalResponseModel();
          this.copyGetAllMetalData = JSON.parse(JSON.stringify(this.getAllMetalData))??[];
        }else{           
          this.getAllMetalData = [];
          this.copyGetAllMetalData = [];
        }  
      },
      error:(err)=>{
        this.getAllMetalData = [];
        this.administrationService.getAllMetalData = [];
        this.copyGetAllMetalData = [];
      }
    })
  }
  
 // *************insert Metal **************
  InserMetalList(item) {
    const {id , ...rest} = item;
    this.administrationService.insertMetal(rest)
        .pipe(catchError((err) => this.handleError(err)))
        .subscribe((res) => {
          if(res.isSuccess){
            this.isAdd = false;
            this.getAllMetalList();
            this.toaster.success(res.message);
          }else{
            this.toaster.error(res.errors[0]);
          }  
      });
    }

  // **********update Metal *********
    UpdateMetalList(item) {
    const {isEdit , ...rest} = item;
    this.administrationService.updateMetal(rest)
        .pipe(catchError((err) => this.handleError(err)))
        .subscribe((res) => {
          if(res.isSuccess){
            
            this.isAdd = false;
            this.getAllMetalList();
            this.toaster.success(res.message);
          }else{
            this.toaster.error(res.errors[0]);
          }  
      });
    }  

    // **********delete Metal *********
    DeleteMetalList(id) {
    if(!this.sendDataService?.permissionVM?.mastersCanDelete) return;
      this.administrationService.deleteMetal(id)
          .pipe(catchError((err) => this.handleError(err)))
          .subscribe((res) => {
            if(res.isSuccess){
              this.getAllMetalList();
              this.toaster.success(res.message);
            }else{
              this.toaster.error(res.errors[0]);
            }  
      });
    }
  
  // *********** METAL API END *********
}
